import React, { useEffect, useState } from "react";
import { SelectInputWTitle } from "./SelectInputWTitle";
import { Loading } from "../Loading";
import { GetDataPromise } from "../Functions/SendingData";
import { apiMain } from "../../App";
import { LoadingColor } from "../LoadingColor";


export const CurrenciesSelector = ({
    style,
    name,
    title,
    error = "",
    first,
    value,
    onchange,
    placeHolder,
    required,
    ltr,
    lan= false,
    disabled=false,
    search = false,
}) => {
    const [loading, setLoading] = useState(false);
    const [data, setDeta] = useState([]);
    // check subsystem
    useEffect(() => {
        if(!loading){
            getData();
        }
    }, [])
    const getData = async () => {
        setLoading(true);
        let res = await GetDataPromise(`${apiMain}/api/v1/setting/currency`);
        let parsed = JSON.parse(res);
        if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
          setDeta(parsed.data);
          setLoading(false);
          return;
        }
        setLoading(false);
    }
    if(loading){
        return (
            <LoadingColor/>
        )
    }
    let options = data.map((v) => {
        return {
            value: v.Currency_Id,
            name: v.Currency_Name
        }
    })
    return (
        <SelectInputWTitle
            style={style}
            name={name}
            title={title}
            error={error}
            options={options}
            first={first}
            value={value}
            onchange={onchange}
            placeHolder={placeHolder}
            required={required}
            ltr={ltr}
            lan={lan}
            disabled={disabled}
            search={search}
        />
    )

};